/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseRegulationDto } from '../../models/response-regulation-dto';

export interface GetAllRegulations$Params {
  limit?: number;
  offset?: number;
  sortBy?: string;
  sortOrder?: 'ASC' | 'DESC';

/**
 * Query parameter search for service provider name or number.
 */
  query?: string;
}

export function getAllRegulations(http: HttpClient, rootUrl: string, params?: GetAllRegulations$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseRegulationDto>> {
  const rb = new RequestBuilder(rootUrl, getAllRegulations.PATH, 'get');
  if (params) {
    rb.query('limit', params.limit, {});
    rb.query('offset', params.offset, {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('sortOrder', params.sortOrder, {});
    rb.query('query', params.query, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseRegulationDto>;
    })
  );
}

getAllRegulations.PATH = '/regulations';
